// ⚠ GENERATED FILE — DO NOT EDIT.
//
// Source of truth: eventsmagic-api `src/boundary/eventFeature.ts` (the features) and
// `src/boundary/eventSetupRules.ts` (the evaluator, copied verbatim). Regenerate with
// `npm run gen:event-setup` in eventsmagic-api. ROADMAP A2b #62 / #63.
//
// ⚠ Never re-implement the evaluator here or anywhere in the app: the wizard, the Features page and the menu must
// decide exactly what the server's guard proves. The RULES themselves are data — they come from `eventSetupCatalog`.
/* eslint-disable */

export const EVENT_SETUP_MODES: string[] = ["link_rsvp","managed_invites","save_the_date","ticketed"];

export const EVENT_CATEGORY_GROUP_VALUES: string[] = ["celebration","milestone","professional","community","other"];

export const EVENT_FEATURE_SECTION = {
  "OVERVIEW": "overview",
  "REGISTRATION": "registration",
  "GAMES": "games",
  "PROGRAM": "program",
  "OPERATIONS": "operations",
  "INVENTORY": "inventory",
  "VOLUNTEERS": "volunteers",
  "PARTNERS": "partners",
  "POLICIES": "policies",
  "WEBSITE": "website"
} as const;

export type EventFeatureSection = (typeof EVENT_FEATURE_SECTION)[keyof typeof EVENT_FEATURE_SECTION];

export const EVENT_FEATURE_STRENGTH = {
  "SUGGESTED": "suggested",
  "OFFERED": "offered"
} as const;

export interface EventFeatureDef {
  code: string;
  name: string;
  /** One line for a setup card — what the host gets. */
  description: string;
  section: EventFeatureSection;
  /** An `AppIcon` name. */
  icon: string;
  /** The PLAN feature that unlocks it (→ premium badge + plan names), or null when every plan has it. */
  planFeatureCode: string | null;
}

/** Every event feature, in declaration order — the order setup screens list them in within a section. */
export const EVENT_FEATURES: readonly EventFeatureDef[] = [
  {"code":"tickets","name":"Tickets","description":"Sell tickets, with discount codes and a box office.","section":"registration","icon":"Ticket","planFeatureCode":"ticketing"},
  {"code":"vouchers","name":"Vouchers","description":"Give guests vouchers — a free drink, a meal — and redeem them.","section":"registration","icon":"Gift","planFeatureCode":"promotions"},
  {"code":"questions","name":"Custom questions","description":"Ask guests what you need to know when they reply.","section":"registration","icon":"ClipboardList","planFeatureCode":null},
  {"code":"policies","name":"Policies & waivers","description":"Terms, waivers and consents guests accept.","section":"policies","icon":"Gavel","planFeatureCode":"pro_registration"},
  {"code":"prize_draws","name":"Prize draws","description":"Draw winners from your guests, live.","section":"games","icon":"Dice","planFeatureCode":"engagement"},
  {"code":"party_games","name":"Party games","description":"Secret Santa, Human Bingo, Mafia and more, on guests’ phones.","section":"games","icon":"Sparkles","planFeatureCode":"engagement"},
  {"code":"sessions","name":"Sessions","description":"Split it into sessions — talks, dinner — each with its own time and people.","section":"overview","icon":"CalendarTime","planFeatureCode":null},
  {"code":"timeline","name":"Timeline","description":"The run of show — what happens when.","section":"program","icon":"Timeline","planFeatureCode":null},
  {"code":"event_map","name":"Event map","description":"A map of the site — stages, stalls, exits.","section":"program","icon":"Map","planFeatureCode":"production"},
  {"code":"pois","name":"Places nearby","description":"Parking, hotels, places to eat — for your guests.","section":"program","icon":"MapPin","planFeatureCode":null},
  {"code":"polls","name":"Polls & quizzes","description":"Ask guests to vote or play a quiz.","section":"program","icon":"ChartBar","planFeatureCode":"engagement"},
  {"code":"signup_list","name":"Sign-up list","description":"Guests sign up for things on a list.","section":"program","icon":"ListCheck","planFeatureCode":"engagement"},
  {"code":"tallies","name":"Tallies","description":"Count things live — drinks served, laps, votes.","section":"program","icon":"Number","planFeatureCode":"engagement"},
  {"code":"race","name":"Race timing","description":"Bibs, start and finish times, and results.","section":"program","icon":"Run","planFeatureCode":"production"},
  {"code":"artists","name":"Artists & speakers","description":"Book performers and speakers, and show the lineup.","section":"program","icon":"Microphone","planFeatureCode":"commercial"},
  {"code":"tasks","name":"Tasks","description":"To-dos and appointments for you and your crew.","section":"operations","icon":"Checklist","planFeatureCode":null},
  {"code":"budget","name":"Budget","description":"Plan costs and track what is paid.","section":"operations","icon":"Wallet","planFeatureCode":"production"},
  {"code":"finance","name":"Finance","description":"Money in and out, for a ticketed event.","section":"operations","icon":"ReportMoney","planFeatureCode":"production"},
  {"code":"rentals","name":"Rentals","description":"Things you rent — pickup, drop-off, cost.","section":"operations","icon":"Package","planFeatureCode":"production"},
  {"code":"vendors","name":"Vendors","description":"Who works your event, and the insurance and permits each one owes.","section":"operations","icon":"Certificate","planFeatureCode":"production"},
  {"code":"qr_tags","name":"QR tags","description":"Codes for wristbands, cards and items — linked to a guest at the door.","section":"operations","icon":"Qrcode","planFeatureCode":"production"},
  {"code":"lost_found","name":"Lost & found","description":"What was found and what was lost — guests report it, the desk hands it back.","section":"operations","icon":"Backpack","planFeatureCode":"production"},
  {"code":"travel","name":"Travel","description":"Who arrives when, and how.","section":"operations","icon":"Plane","planFeatureCode":null},
  {"code":"accommodations","name":"Accommodations","description":"Where out-of-town guests stay.","section":"operations","icon":"Bed","planFeatureCode":null},
  {"code":"files","name":"Files","description":"Contracts, plans and photos in one place.","section":"operations","icon":"Folder","planFeatureCode":null},
  {"code":"notes","name":"Notes","description":"Notes for you and your crew.","section":"operations","icon":"Notes","planFeatureCode":null},
  {"code":"inventory","name":"Inventory","description":"Stock you bring — receive, move and count it by scanning.","section":"inventory","icon":"Packages","planFeatureCode":"production"},
  {"code":"volunteers","name":"Volunteers & staff","description":"Shifts, applications, check-in and staff pay.","section":"volunteers","icon":"HeartHandshake","planFeatureCode":"production"},
  {"code":"partners","name":"Partners & sponsors","description":"Sponsorship packages, applications and partners.","section":"partners","icon":"Building","planFeatureCode":"commercial"},
  {"code":"donations","name":"Donations","description":"Collect gifts for your causes — online and at the door, with receipts.","section":"partners","icon":"Heart","planFeatureCode":"commercial"},
  {"code":"marketing_channels","name":"Marketing channels","description":"Tracked links — see which channel brings guests.","section":"website","icon":"Speakerphone","planFeatureCode":null},
];

export const EVENT_FEATURE_CODES: string[] = EVENT_FEATURES.map((f) => f.code);

export const isEventFeatureCode = (code: unknown): code is string => typeof code === "string" && EVENT_FEATURE_CODES.includes(code);

export const eventFeatureDef = (code: string): EventFeatureDef | null => EVENT_FEATURES.find((f) => f.code === code) ?? null;

export interface EventFeatureSettings {
  on: string[];
}

/** The features an event uses, given its `settings.features` (null = all of them). */
export const eventFeaturesOn = (settings: { features?: EventFeatureSettings | null } | null | undefined): string[] => {
  const on = settings?.features?.on;

  if (!Array.isArray(on)) {
    return [...EVENT_FEATURE_CODES];
  }

  return EVENT_FEATURE_CODES.filter((code) => on.includes(code));
};

/** One plan feature an event's chosen features need, and which of them need it. */
export interface PremiumFeaturesGroup {
  planFeatureCode: string;
  features: string[];
}

/**
 * ROADMAP #62 P6c — the PREMIUM features an event has chosen, grouped by the PLAN feature that unlocks them: what the
 * publish gate asks the account's plan about (EventCore on publish; the wizard's finish screen, which lists them with a
 * Remove each).
 *
 * ⚠⚠ NO RECORD → NONE. "Absent means everything on" is the MENU's rule for events made before #62 — read here, it would
 * refuse to publish every one of them.
 */
export const premiumFeaturesInUse = (settings: { features?: EventFeatureSettings | null } | null | undefined): PremiumFeaturesGroup[] => {
  const on = settings?.features?.on;

  if (!Array.isArray(on)) {
    return [];
  }

  const groups: PremiumFeaturesGroup[] = [];

  for (const def of EVENT_FEATURES) {
    if (!def.planFeatureCode || !on.includes(def.code)) {
      continue;
    }

    const group = groups.find((g) => g.planFeatureCode === def.planFeatureCode);

    if (group) {
      group.features.push(def.code);
    } else {
      groups.push({ planFeatureCode: def.planFeatureCode, features: [def.code] });
    }
  }

  return groups;
};

// ─── Ready-made registration questions (from eventQuestionStarters.ts) ──────────────────────────────────────────

export interface EventQuestionStarter {
  id: string;
  title: string;
  /** An `AppIcon` name. */
  icon: string;
  personField: string | null;
  questionType: string;
  valueType: string;
  options: string[];
  requiredScope: string;
  helpText: string | null;
  askOncePerGroup: boolean;
}

/** The wizard's one-tap question starters. A type picks its own with the `questionIdeas` offer option. */
export const EVENT_QUESTION_STARTERS: readonly EventQuestionStarter[] = [
  {"personField":"email","questionType":"single_value","valueType":"email","options":[],"requiredScope":"adults","helpText":null,"askOncePerGroup":false,"id":"email","title":"Email","icon":"Mail"},
  {"personField":"phone","questionType":"single_value","valueType":"phone","options":[],"requiredScope":"adults","helpText":null,"askOncePerGroup":false,"id":"phone","title":"Phone number","icon":"Phone"},
  {"personField":"dietaryRestrictions","questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"all","helpText":"Write “none” if there are none.","askOncePerGroup":false,"id":"dietary","title":"Dietary restrictions or allergies","icon":"ToolsKitchen2"},
  {"personField":null,"questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"accessibility","title":"Accessibility needs","icon":"Accessible"},
  {"personField":null,"questionType":"single_choice","valueType":"short_text","options":["Meat","Fish","Vegetarian","Vegan"],"requiredScope":"all","helpText":null,"askOncePerGroup":false,"id":"meal_choice","title":"Meal choice","icon":"Salad"},
  {"personField":null,"questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"song_request","title":"Song request","icon":"Music"},
  {"personField":null,"questionType":"single_value","valueType":"boolean","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":true,"id":"accommodation","title":"Do you need a place to stay?","icon":"Bed"},
  {"personField":"company","questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"adults","helpText":null,"askOncePerGroup":false,"id":"company","title":"Company","icon":"Building"},
  {"personField":"jobTitle","questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"job_title","title":"Job title","icon":"Briefcase"},
  {"personField":"socialUrl1","questionType":"single_value","valueType":"url","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"linkedin","title":"LinkedIn profile","icon":"BrandLinkedin"},
  {"personField":null,"questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"industry","title":"Industry","icon":"BuildingSkyscraper"},
  {"personField":null,"questionType":"single_value","valueType":"long_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"looking_to_meet","title":"Who would you like to meet?","icon":"UsersGroup"},
  {"personField":null,"questionType":"single_value","valueType":"long_text","options":[],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"event_goal","title":"What do you hope to get out of this event?","icon":"Target"},
  {"personField":null,"questionType":"single_choice","valueType":"short_text","options":["XS","S","M","L","XL","XXL"],"requiredScope":"all","helpText":null,"askOncePerGroup":false,"id":"tshirt_size","title":"T-shirt size","icon":"Shirt"},
  {"personField":null,"questionType":"single_value","valueType":"short_text","options":[],"requiredScope":"primary","helpText":null,"askOncePerGroup":true,"id":"emergency_contact","title":"Emergency contact (name and phone)","icon":"FirstAidKit"},
  {"personField":null,"questionType":"single_choice","valueType":"short_text","options":["Beginner","Intermediate","Advanced"],"requiredScope":"none","helpText":null,"askOncePerGroup":false,"id":"experience_level","title":"Experience level","icon":"Stairs"},
  {"personField":null,"questionType":"single_choice","valueType":"short_text","options":["A friend or colleague","LinkedIn","Other social media","Email","Search engine","Other"],"requiredScope":"none","helpText":null,"askOncePerGroup":true,"id":"how_heard","title":"How did you hear about us?","icon":"Speakerphone"},
  {"personField":"birthday","questionType":"single_value","valueType":"date","options":[],"requiredScope":"all","helpText":null,"askOncePerGroup":false,"id":"birthday","title":"Date of birth","icon":"Cake"},
];

/** Offered on EVERY event (the public forms ask for names only). */
export const EVENT_QUESTION_STARTERS_ALWAYS: string[] = ["email","phone","dietary"];

// ─── The setup-rule evaluator (verbatim from eventSetupRules.ts) ─────────────────────────────────────────────────

/** When a rule applies. Every present key must match (AND); within a key, any listed value matches (OR). */
export interface EventSetupCondition {
  eventModes?: string[];
  /** Matches the event's type OR its parent type — "holiday_party" covers "christmas_party". */
  categoryCodes?: string[];
  categoryGroups?: string[];
  /** Every listed feature must be on. */
  featuresOn?: string[];
  /** The brand (space) — a rule for PartyLabz only. */
  spaceIds?: string[];
}

export interface EventSetupDisable {
  feature: string;
  /** Shown on the unavailable card — WHY, in the host's words. Required: an unexplained grey card reads as broken. */
  reason: string;
  /** The mode that would make it available, offered to the host as a switch they choose to make. */
  unlock?: { eventMode: string };
}

/** What a rule does. */
export interface EventSetupEffect {
  /** Turn on — for what a mode cannot work without (a ticketed event has Tickets). */
  enable?: string[];
  /** Offer first / pre-tick. */
  suggest?: string[];
  /** Make unavailable, with the reason. ⚠ Disable WINS over enable and over the host's own choice. */
  disable?: EventSetupDisable[];
}

export interface EventSetupRule {
  code: string;
  condition: EventSetupCondition;
  effect: EventSetupEffect;
}

export interface EventSetupState {
  eventMode: string | null;
  categoryCode: string | null;
  parentCategoryCode?: string | null;
  categoryGroup?: string | null;
  /** What the host (or the type's suggestions) has on so far. */
  featuresOn: string[];
  spaceId?: string | null;
}

export interface EventSetupOutcome {
  /** On after the rules — in `EVENT_FEATURE_CODES` order. */
  on: string[];
  /** Suggested by a rule and not disabled — in `EVENT_FEATURE_CODES` order. */
  suggested: string[];
  /** Unavailable, keyed by feature code. */
  disabled: Record<string, { reason: string; unlock?: { eventMode: string } }>;
  /** Codes of the rules that applied, in the order they did — for analytics and for debugging a seed. */
  fired: string[];
}

const anyOf = (list: string[] | undefined, values: Array<string | null | undefined>): boolean =>
  !list || list.length === 0 || values.some((v) => !!v && list.includes(v));

/** True when `condition` holds for `state`, with `on` as the features currently on. */
export const setupConditionHolds = (condition: EventSetupCondition, state: EventSetupState, on: Set<string>): boolean => {
  if (!anyOf(condition.eventModes, [state.eventMode])) {
    return false;
  }

  if (!anyOf(condition.categoryCodes, [state.categoryCode, state.parentCategoryCode])) {
    return false;
  }

  if (!anyOf(condition.categoryGroups, [state.categoryGroup])) {
    return false;
  }

  if (!anyOf(condition.spaceIds, [state.spaceId])) {
    return false;
  }

  if (condition.featuresOn && condition.featuresOn.some((code) => !on.has(code))) {
    return false;
  }

  return true;
};

const inCatalogOrder = (codes: Iterable<string>): string[] => {
  const set = new Set(codes);

  return EVENT_FEATURE_CODES.filter((code) => set.has(code));
};

/**
 * Apply `rules` (in the order given — seed `order_no`) to `state`.
 *
 * ⚠ Evaluated to a FIXED POINT, because an `enable` can satisfy another rule's `featuresOn`. It terminates: a rule
 * fires at most once, and firing only ever ADDS to what is on — nothing a rule does can make another rule stop
 * matching. Disables are collected along the way and applied LAST, so a disable always wins, whatever order the rows
 * are in.
 */
export const evaluateSetupRules = (rules: readonly EventSetupRule[], state: EventSetupState): EventSetupOutcome => {
  const on = new Set(state.featuresOn.filter((code) => EVENT_FEATURE_CODES.includes(code)));
  const suggested = new Set<string>();
  const disabled: EventSetupOutcome['disabled'] = {};
  const fired: string[] = [];
  const done = new Set<number>();
  let changed = true;

  while (changed) {
    changed = false;

    rules.forEach((rule, index) => {
      if (done.has(index) || !setupConditionHolds(rule.condition, state, on)) {
        return;
      }

      done.add(index);
      fired.push(rule.code);
      changed = true;

      (rule.effect.enable ?? []).forEach((code) => on.add(code));
      (rule.effect.suggest ?? []).forEach((code) => suggested.add(code));
      (rule.effect.disable ?? []).forEach((d) => {
        if (!disabled[d.feature]) {
          disabled[d.feature] = d.unlock ? { reason: d.reason, unlock: { ...d.unlock } } : { reason: d.reason };
        }
      });
    });
  }

  Object.keys(disabled).forEach((code) => {
    on.delete(code);
    suggested.delete(code);
  });

  return { on: inCatalogOrder(on), suggested: inCatalogOrder(suggested), disabled, fired };
};

// ─── Validation — run by `check-event-setup` on every seeded row ────────────────────────────────────────────────

const CONDITION_KEYS = ['eventModes', 'categoryCodes', 'categoryGroups', 'featuresOn', 'spaceIds'];
const EFFECT_KEYS = ['enable', 'suggest', 'disable'];
const DISABLE_KEYS = ['feature', 'reason', 'unlock'];

const isStringList = (v: unknown): v is string[] => Array.isArray(v) && v.every((x) => typeof x === 'string' && x.length > 0);

/**
 * Problems with one rule's SHAPE, as sentences (empty = valid). ⚠ jsonb accepts anything, and a misspelt key
 * (`eventMode` for `eventModes`) is read by nothing — the rule then matches EVERY event, silently. So unknown keys
 * are refused, not ignored. Category codes are checked by the guard against the seed (the boundary cannot see it).
 */
export const setupRuleProblems = (rule: { code?: unknown; condition?: unknown; effect?: unknown }): string[] => {
  const problems: string[] = [];
  const code = typeof rule.code === 'string' && rule.code ? rule.code : '(no code)';
  const condition = rule.condition as Record<string, unknown> | null | undefined;
  const effect = rule.effect as Record<string, unknown> | null | undefined;

  if (!condition || typeof condition !== 'object' || Array.isArray(condition)) {
    return [`${code}: condition must be an object`];
  }

  if (!effect || typeof effect !== 'object' || Array.isArray(effect)) {
    return [`${code}: effect must be an object`];
  }

  Object.keys(condition).forEach((key) => {
    if (!CONDITION_KEYS.includes(key)) {
      problems.push(`${code}: unknown condition key "${key}"`);
    } else if (!isStringList(condition[key])) {
      problems.push(`${code}: condition.${key} must be a list of strings`);
    }
  });

  if (Object.keys(condition).length === 0) {
    problems.push(`${code}: an empty condition applies to every event — say what it is for`);
  }

  (isStringList(condition.eventModes) ? condition.eventModes : []).forEach((m) => {
    if (!EVENT_SETUP_MODES.includes(m)) {
      problems.push(`${code}: unknown event mode "${m}"`);
    }
  });

  (isStringList(condition.categoryGroups) ? condition.categoryGroups : []).forEach((g) => {
    if (!(EVENT_CATEGORY_GROUP_VALUES as string[]).includes(g)) {
      problems.push(`${code}: unknown category group "${g}"`);
    }
  });

  (isStringList(condition.featuresOn) ? condition.featuresOn : []).forEach((f) => {
    if (!EVENT_FEATURE_CODES.includes(f)) {
      problems.push(`${code}: condition names unknown feature "${f}"`);
    }
  });

  Object.keys(effect).forEach((key) => {
    if (!EFFECT_KEYS.includes(key)) {
      problems.push(`${code}: unknown effect key "${key}"`);
    }
  });

  ['enable', 'suggest'].forEach((key) => {
    if (effect[key] === undefined) {
      return;
    }

    if (!isStringList(effect[key])) {
      problems.push(`${code}: effect.${key} must be a list of feature codes`);

      return;
    }

    (effect[key] as string[]).forEach((f) => {
      if (!EVENT_FEATURE_CODES.includes(f)) {
        problems.push(`${code}: effect.${key} names unknown feature "${f}"`);
      }
    });
  });

  if (effect.disable !== undefined) {
    if (!Array.isArray(effect.disable)) {
      problems.push(`${code}: effect.disable must be a list`);
    } else {
      (effect.disable as Array<Record<string, any>>).forEach((d, i) => {
        if (!d || typeof d !== 'object') {
          problems.push(`${code}: effect.disable[${i}] must be an object`);

          return;
        }

        Object.keys(d).forEach((key) => {
          if (!DISABLE_KEYS.includes(key)) {
            problems.push(`${code}: effect.disable[${i}] has unknown key "${key}"`);
          }
        });

        if (!EVENT_FEATURE_CODES.includes(d.feature)) {
          problems.push(`${code}: effect.disable[${i}] names unknown feature "${d.feature}"`);
        }

        if (typeof d.reason !== 'string' || !d.reason.trim()) {
          problems.push(`${code}: effect.disable[${i}] has no reason — the host must be told why`);
        }

        if (d.unlock !== undefined && !(d.unlock && EVENT_SETUP_MODES.includes(d.unlock.eventMode))) {
          problems.push(`${code}: effect.disable[${i}].unlock must name a real event mode`);
        }
      });
    }
  }

  const hasEffect = ['enable', 'suggest', 'disable'].some((k) => Array.isArray(effect[k]) && (effect[k] as unknown[]).length);

  if (!hasEffect) {
    problems.push(`${code}: the effect does nothing`);
  }

  return problems;
};
